/** @flow */

import type { State } from "@store/reducers";
import type { EmployeeType } from "@modules/employee/types";

export const getEmployeeDetails = (state: State): Object =>
  state.reporting.employee.employeeDetails;

export const getDetails = (state: State): ?EmployeeType => getEmployeeDetails(state).details;

export const isLoading = (state: State): boolean => {
  return state.reporting.employee.employeeDetails.requestsInProgress > 0;
};
